// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fmh8D","content":"styles_content__o40Go","decline":"styles_decline__ZIhkZ"};